export default {
    TEST_SLIDE_ONE: "Slide one!",
    TEST_SLIDE_TWO: "22222",
    TEST_SLIDE_THR: "thr",
    BUTTON_PREV: "previousButton",
    BUTTON_NEXT: "nextButton",
};